import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

export const CitoBasePreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{primary.color}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
    colorScheme: {
      light: {
        primary: {
          color: '{blue.800}',
          contrastColor: '#ffffff',
          hoverColor: '{blue.600}',
          activeColor: '{primary.color}',
        },
        highlight: {
          background: 'var(--primeng-highlight-bg)',
          focusBackground: 'var(--primeng-highlight-bg)',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
      },
    },
  },
  components: {
    menubar: {
      root: {
        background: 'var(--menubar-background-color)',
      },
      separator: {
        borderColor: 'var(--menubar-separator-color)',
      },
      item: {
        color: 'var(--primeng-menubar-item-color)',
        activeColor: 'var(--primeng-menubar-item-active-color)',
        activeBackground: 'var(--primeng-menubar-item-active-bg)',
        focusBackground: 'var(--primeng-menubar-item-hover-bg)',
        focusColor: 'var(--primeng-menubar-item-active-color)',
        icon: {
          color: 'var(--primeng-menubar-item-color)',
          activeColor: 'var(--primeng-menubar-item-active-color)',
          focusColor: 'var(--primeng-menubar-item-active-color)',
        },
      },
      submenu: {
        background: 'var(--primeng-submenu-bg)',
        icon: {
          color: 'var(--primeng-menubar-item-color)',
          focusColor: 'var(--primeng-menubar-item-color)',
          activeColor: 'var(--primeng-menubar-item-color)',
        },
      },
    },
  },
});
